import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M17 4h3v16h-3zM5 14h3v6H5zm6-5h3v11h-3z"
}), 'SignalCellularAlt');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/SignalCellularAlt.js
// module id = 6158
// module chunks = 2